module.exports = __webpack_public_path__ + "img/favicon.f55784f0.png";